const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(() => {
  if (window.Shopify?.designMode) return;

  const localePrefixes = ['ar','de','es','fr','hi','it','ja','ko','nl','pl','pt','ru','sv','tr','uk','zh-hans','zh-hant'];
  const currentPath = window.location.pathname || '/';
  const explicitPrefix = localePrefixes.find((p) => currentPath === `/${p}` || currentPath.startsWith(`/${p}/`));

  // Respect an explicit language URL chosen by the customer or a search engine.
  if (explicitPrefix) {
    sessionStorage.setItem('kp:auto-locale-v2', '1');
    return;
  }
  if (sessionStorage.getItem('kp:auto-locale-v2') === '1') return;

  const country = String(window.Shopify?.country || '').toUpperCase();
  const browser = String((navigator.languages && navigator.languages[0]) || navigator.language || 'en').toLowerCase();
  const browserBase = browser.split('-')[0];

  const spanishLatam = ['MX','AR','CL','CO','PE','UY','PY','BO','EC','VE','CR','PA','GT','HN','SV','NI','DO'];
  const arabicMarkets = ['AE','SA','QA','KW','BH','OM','JO','LB','EG','MA','DZ','TN','IQ'];
  const supportedBrowser = {
    ar: 'ar', de: 'de', es: 'es', fr: 'fr', hi: 'hi', it: 'it', ja: 'ja', ko: 'ko',
    nl: 'nl', pl: 'pl', pt: 'pt', ru: 'ru', sv: 'sv', tr: 'tr', uk: 'uk',
    zh: browser.includes('tw') || browser.includes('hk') || browser.includes('hant') ? 'zh-hant' : 'zh-hans'
  };

  let target = 'en';
  if (country === 'PT' || country === 'BR') target = 'pt';
  else if (country === 'ES' || spanishLatam.includes(country)) target = 'es';
  else if (country === 'FR') target = 'fr';
  else if (country === 'DE' || country === 'AT') target = 'de';
  else if (country === 'IT') target = 'it';
  else if (country === 'NL') target = 'nl';
  else if (country === 'PL') target = 'pl';
  else if (country === 'SE') target = 'sv';
  else if (country === 'RU') target = 'ru';
  else if (country === 'UA') target = 'uk';
  else if (country === 'TR') target = 'tr';
  else if (country === 'JP') target = 'ja';
  else if (country === 'KR') target = 'ko';
  else if (country === 'CN') target = 'zh-hans';
  else if (['TW','HK','MO'].includes(country)) target = 'zh-hant';
  else if (country === 'IN') target = browserBase === 'hi' ? 'hi' : 'en';
  else if (arabicMarkets.includes(country)) target = 'ar';
  else if (country === 'CA') target = browserBase === 'fr' ? 'fr' : 'en';
  else if (country === 'BE') target = browserBase === 'fr' ? 'fr' : 'nl';
  else if (country === 'CH') target = ['fr','it','de'].includes(browserBase) ? browserBase : 'de';
  else if (supportedBrowser[browserBase]) target = supportedBrowser[browserBase];

  sessionStorage.setItem('kp:auto-locale-v2', '1');
  if (target === 'en') return;

  const localizedPath = `/${target}${currentPath === '/' ? '/' : currentPath}`.replace(/\/+/g, '/');
  const next = `${localizedPath}${window.location.search}${window.location.hash}`;
  window.location.replace(next);
})();
